import React, { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingSpinner from './Components/LoadingSpinner';

const ProtectedRoute = () => {
  const token = localStorage.getItem('access_token');
  const [checking, setChecking] = useState(true); 
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    if (!token) {
      toast.error('You are not an Authenticated user!', {
        autoClose: 1500,
        toastId: 'unauthenticated', 
      });
      setTimeout(() => {
        setRedirect(true);
        setChecking(false);
      }, 1500);
    } else {
      setChecking(false);
    }
  }, [token]);


  if (checking) {
    return <LoadingSpinner isLoading={true} />;
  }

 
  if (!token && redirect) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
